export const LoggingConstants = {
    // Logging related constants declaration by Devisingh
    LOGGING_TIMESTAMP_PARAM_LABEL: 'Time',
    LOGGING_EVENTTYPE_PARAM_LABEL: 'EventType',
    LOGGING_REQUESTTYPE_PARAM_LABEL: 'RequestType',
    LOGGING_RESOURCENAME_PARAM_LABEL: 'ResourceName',
    LOGGING_RESOURCEINSTANCE_PARAM_LABEL: 'ResourceInstance',
    LOGGING_USERACTION_PARAM_LABEL: 'UserAction',
    LOGGING_LIFECYCLE_PARAM_LABEL: 'Lifecycle',
    LOGGING_HOST_PARAM_LABEL: 'Host',
    LOGGING_CLIENTID_PARAM_LABEL: 'ClientId',
    LOGGING_CONSUMERREFERID_PARAM_LABEL: 'ConsumerRefID',
    LOGGING_LOCALE_PARAM_LABEL: 'Locale',
    LOGGING_DEFAULT_VALUE_LABEL: null,
    EVENT_TYPE_USAGE_LABEL: 'UxUsage',
    EVENT_TYPE_DEBUG_LABEL: 'UxDebug',
    EVENT_TYPE_ERROR_LABEL: 'UxError',
    EVENT_TYPE__PAGEUSAGE_LABEL: 'UxPageUsage',
    EVENT_TYPE__UXSCREENCAPTURE_LABEL: 'UxScreenCapture',
    EVENT_TYPE__RENDEREVENTS_LABEL: 'UxRenderEvent',
    LOGGING_POST_SERVER_ENDPOINT_URL: 'channel/eventlog',
    LOG_LEVEL_CONFIG_URL: 'channel/eventlog/logConfiguration',
    INFO: 'INFO',
    DEBUG: 'DEBUG',
    ERROR: 'ERROR',
    WARN: 'WARN',
    FATAL: 'FATAL',
    GLOBAL_SRC_IP_VALUE: '0.0.0.0',
    GLOBAL_USAGE_LEVEL_SEVERITY: 'DEBUG',
    GLOBAL_PAGE_USAGE_LEVEL_SEVERITY: 'DEBUG',
    LOG_REMOTE_CALL_MSG: 'Remote Service Call',
    LOG_REMOTE_CALL_RESPONSE_MSG: 'Remote Service Response',
    LOG_REMOTE_CALL_ERROR_MSG: 'Remote Service Error',
    LOG_APP_USAGE: 'Application Operation Usage',
    LOG_APP_PAGE_USAGE: 'Page Usage/User Action',
    LOG_USER_ACTION_CONSTANT_VALUE: 'Api Remote Call',
    IS_LOGGING_LOCAL_ENABLED: false,
    IS_IDB_ENABLED_IN_BROWSER: true // For checking Indexed Db is enabled or not in case DOM storage disabled/Private browsing etc.
};
